import { useEffect, useState } from "react";
import { Smartphone, CreditCard } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export const usePaymentConfig = () => {
  const [cfg, setCfg] = useState({ razorpay_enabled: false });
  useEffect(() => { api.get("/payments/config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  return cfg;
};

export const PaymentMethodPicker = ({ value, onChange, razorpayEnabled }) => {
  const { L } = useLang();
  const opts = [
    { id: "razorpay", icon: Smartphone, t: L("UPI QR · Indian cards · Net banking", "UPI QR · भारतीय कार्ड · नेट बैंकिंग"), d: "Razorpay (secure)", disabled: !razorpayEnabled },
  ];
  return (
    <div className="grid grid-cols-1 gap-3" data-testid="payment-method-picker">
      {opts.map((o) => (
        <button type="button" key={o.id} disabled={o.disabled} onClick={() => onChange(o.id)} data-testid={`pay-method-${o.id}`}
          className={`text-left p-3 rounded-xl border-2 bg-white transition-[border-color] ${value === o.id ? "border-[#FF2E63]" : "border-slate-200 hover:border-slate-400"} disabled:opacity-50 disabled:cursor-not-allowed`}>
          <o.icon className="w-5 h-5 text-[#FF2E63]" />
          <div className="font-bold text-sm mt-1 text-[#0A192F]">{o.t}</div>
          <div className="text-[11px] text-slate-500">{o.disabled ? L("Online payment is being switched on. Please call 9608321115 or WhatsApp 8100499334.", "ऑनलाइन भुगतान जल्द चालू होगा। कृपया 9608321115 पर कॉल या 8100499334 पर WhatsApp करें।") : o.d}</div>
        </button>
      ))}
    </div>
  );
};
